import { GretaAIChatSource } from '../../../GretaAIChat.constants'

import InvoiceIcon from '../../../../../icons/invoice.svg'
import ServiceRequestIcon from '../../../../../icons/service-request.svg'

export const GRETA_AI_CHAT_SOURCE_ICON = {
  [GretaAIChatSource.Crm]: ServiceRequestIcon,
  [GretaAIChatSource.Finance]: InvoiceIcon,
}

export const GRETA_AI_CHAT_SOURCE_PICKER_GRADIENT_ID_PREFIX =
  'greta-ai-chat-source-picker'
